import { useEffect, useMemo, useState } from 'react'
import { Link } from "react-router-dom"
import { Table, Select, Space, Input, Button, Form, Modal, DatePicker, message } from 'antd'
import { SearchOutlined, RedoOutlined, } from '@ant-design/icons'
import baseAxios, { baseAxiosNoInfo, axiosTable } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import BreadCrumb from '../../component/BreadCrumb'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type pagination = {
  current: number,
  pageSize: number,
  total: number,
  showSizeChanger: boolean
}

type fetchParams = {
  store_id: string | undefined,
  customer_name: string | undefined,
  customer_phone: string | undefined,
  customer_type: string | undefined,
  customer_source_id: string | undefined,
  employee_id_adviser: string | undefined,
  expectBornDay: any,
  dealDate: any,
  checkInDay: any
}

export default function CkCustomerList() {
  let otherParamsTml = {
    store_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    customer_type: undefined,
    customer_source_id: undefined,
    employee_id_adviser: undefined,
    expectBornDay: null,
    dealDate: null,
    checkInDay: null
  }

  let paginatioTml = {
    current: 1,
    pageSize: 8,
    total: 0,
    showSizeChanger: false
  }

  const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
  const [pagination, setPagination] = useState<pagination>(paginatioTml)

  const [tableList, setTableList] = useState<any[]>([])
  const [adviseEmployeeList, setAdviseEmployeeList] = useState<any[]>([])
  const [sourceList, setSourceList] = useState<any[]>([])

  const [showType, setShowType] = useState<string>('')
  const [addVisible, setAddVisible] = useState<boolean>(false)

  const [customerId, setCustomerId] = useState<string>('')
  const [memberID, setMemberID] = useState<string>('')

  const [customerRef] = Form.useForm()

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    fetch({ pagination, otherParams })
  }, [pagination.current])

  useEffect(() => {
    getEmployeeList('')

    // 客户来源
    baseAxiosNoInfo('/chankang_center/customer_source_list').then((res: any) => {
      if (res) {
        setSourceList(res)
      }
    })
  }, [])

  const getEmployeeList = (id: any) => {
    // 产康顾问
    baseAxiosNoInfo('/global/employee_list_by_position', { params: { position_number: 4, department_id: id } }).then((res: any) => {
      if (res) {
        setAdviseEmployeeList(res)
      }
    })
  }

  const handleInputChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSelectChange = (value: string, attr: string) => {
    if (attr == 'store_id') {
      getEmployeeList(value)
    }

    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleChange = (value: any, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSearch = () => {
    fetch({ pagination, otherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current

    setPagination(p)
  }

  const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }

    handleDate(params, 'expectBornDay', ['start_expect_born_day', 'end_expect_born_day'])
    handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])
    handleDate(params, 'checkInDay', ['start_check_in_day', 'end_check_in_day'])

    axiosTable.get('/chankang_center/customer/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setTableList(response.records)
      }
    })
  }

  const resetForm = () => {
    setOtherParams(otherParamsTml)

    let p: any = { ...pagination }
    p.current = 1

    setPagination(p)
    fetch({ pagination: p, otherParams: otherParamsTml })
  }

  const handleAdd = () => {
    setShowType('add')

    customerRef.setFieldsValue({
      customer_name: '',
      customer_phone: '',
      customer_source_desc: '',
      customer_source_id: '',
      employee_id_adviser: '',
      remark: '',
    })

    setAddVisible(true)
  }

  const handleEdit = (record: any) => {
    setShowType('edit')

    customerRef.setFieldsValue({
      customer_name: record.customer_name,
      customer_phone: record.customer_phone,
      customer_source_desc: record.customer_source_desc,
      customer_source_id: record.customer_source_id,
      employee_id_adviser: record.employee_id_adviser,
      remark: record.remark,
    })

    setCustomerId(record.customer_id)
    setAddVisible(true)
  }

  // 关闭弹框
  const changeCancel = () => {
    setAddVisible(false)
  }

  // 提交添加修改
  const confirmAdd = (value: any) => {
    let data = {
      customer_id: '',
      customer_name: value.customer_name,
      customer_phone: value.customer_phone,
      customer_source_id: value.customer_source_id,
      employee_id_adviser: value.employee_id_adviser,
      remark: value.remark,
      member_id: memberID
    }

    let url = ''
    if (showType == 'add') {
      url = '/chankang_center/customer/add'

    } else {
      data.customer_id = customerId
      url = '/chankang_center/customer/update'
    }

    baseAxios.post(url, { ...data }).then((res: any) => {
      if (res) {
        resetForm()
        setAddVisible(false)
      }
    })
  }

  // 手机号校验
  const searchVip = (e: React.FocusEvent<HTMLInputElement>) => {
    baseAxiosNoInfo('/chankang_center/customer/is_exist', { params: { customer_phone: e.target.value } }).then((res: any) => {
      if (res && res.customer_id != null) {

      } else {
        customerRef.setFieldsValue({ customer_phone: e.target.value })
      }
    })
  }

  // 验证账号是否已经被添加过，这个是rules自定义的验证方法
  const checkAccount = (value: string | number) => {
    return new Promise((resolve, reject) => {
      // 返回一个promise
      baseAxiosNoInfo('/chankang_center/customer/is_exist', { params: { customer_phone: value } }).then((res: any) => {
        // 校验手机号存在时，若添加是校验，修改则不校验
        if (res && res.customer_id != null && showType == 'add') {
          resolve(false)

        } else {
          resolve(true)
          customerRef.setFieldsValue({ customer_phone: value })
        }
      })
    })
  }

  function handleDate(param: any, attr: string, realDateParams: string[]): void {
    if (param[attr]) {
      param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
      param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

      delete param[attr]
    }
  }

  const getAdviseEmployeeList = adviseEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))
  const getSourceList = sourceList.map((el: any) => (<Option value={el.source_id} key={el.source_id}  >{el.source_name}</Option>))

  return <div className="common-page">
    {/* 产康中心 -> 产康客户管理 -> 产康客户列表 */}
    <BreadCrumb position={['产康中心', '产康客户列表']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores value={otherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
        </div>
        <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_name} placeholder="客户名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_name') }} />
        <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_phone} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_phone') }} />

        <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={otherParams.customer_type} onChange={(value: string) => { handleSelectChange(value, 'customer_type') }} placeholder="客户类型">
          <Option value="1">产康自建</Option>
          <Option value="2">月子签单</Option>
          <Option value="3">月嫂签单</Option>
        </Select>
        <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={otherParams.employee_id_adviser} onChange={(value: string) => { handleSelectChange(value, 'employee_id_adviser') }} placeholder="产康顾问">
          {getAdviseEmployeeList}
        </Select>

        <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 300 }} className="fl" placeholder={["预产期开始日期", "预产期结束日期"]} value={otherParams.expectBornDay} onChange={(v: any) => { handleChange(v, 'expectBornDay') }} />
        <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["签单开始日期", "签单结束日期"]} value={otherParams.dealDate} onChange={(v: any) => { handleChange(v, 'dealDate') }} />

        <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["入住开始日期", "入住结束日期"]} value={otherParams.checkInDay} onChange={(v: any) => { handleChange(v, 'checkInDay') }} />
      </Space>

      <div style={{ marginTop: 10 }}>
        {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
        {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={handleAdd}>添加</Button>}
      </div>
    </div>

    <div className="common-main">
      <Table dataSource={tableList} scroll={{ x: 'max-content' }} bordered={true} rowKey="customer_id" pagination={pagination} onChange={handleTableChange}>
        <Column fixed title="操作" key="action" render={(text, record: any) => (
          <Space size="middle">
            <Button type="link">
              <Link to={"/ck_customer_detail/" + record.customer_id}>查看</Link>
            </Button>

            <Button type="primary" onClick={() => handleEdit(record)}>编辑</Button>
          </Space>
        )} />

        <Column title="门店名称" dataIndex="store_name" key="store_name" />
        <Column title="客户姓名" dataIndex="customer_name" key="customer_name" />
        <Column title="客户手机号" dataIndex="customer_phone" key="customer_phone" />
        <Column title="客户类型" dataIndex="customer_type_desc" key="customer_type_desc" />
        <Column title="客户来源" dataIndex="customer_source_desc" key="customer_source_desc" />

        <Column title="客户预产期" dataIndex="expect_born_day" key="expect_born_day" />
        <Column title="客户签单日期" dataIndex="deal_date" key="deal_date" />

        <Column title="胎次" dataIndex="mother_parity_desc" key="mother_parity_desc" />
        <Column title="购买月子套餐" dataIndex="buy_yuezi_type_desc" key="buy_yuezi_type_desc" />
        <Column title="宝妈产后修复意识" dataIndex="mother_repair_mentality_desc" key="mother_repair_mentality_desc" />
        <Column title="产康消费总金额" dataIndex="total_actually_deal_amount" key="total_actually_deal_amount" />

        <Column title="服务状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
        <Column title="服务开始日期" dataIndex="check_in_time" key="check_in_time" />
        <Column title="服务结束日期" dataIndex="check_out_time" key="check_out_time" />

        <Column title="护理模式" dataIndex="nursing_care_type_desc" key="nursing_care_type_desc" />
        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="备注" dataIndex="remark" key="remark" />
      </Table>
    </div>

    <Modal title={showType == 'add' ? '新增产康客户' : '编辑产康客户'} visible={addVisible} onCancel={changeCancel} footer={false} width="500px">
      <Form {...formItemLayout} form={customerRef} onFinish={confirmAdd} >
        <Form.Item label="客户姓名" name="customer_name" rules={[{ required: true, message: '必须填写客户姓名' }]} >
          <Input placeholder="" disabled={showType == 'add' ? false : true} />
        </Form.Item>

        <Form.Item label="会员手机号" name="vip_phone"  >
          <Input placeholder="搜索会员" onBlur={(e) => {
            baseAxiosNoInfo('/global/member_list', {
              params: {
                phone: e.target.value
              }
            }).then((res: any) => {
              if (res && res.length > 0) {
                message.info('已查询到' + res[0].user_name)
                setMemberID(res[0].id)

              } else {
                message.info('无此会员相关信息')
              }
            })
          }} />
        </Form.Item>

        <Form.Item label="手机号" name="customer_phone"
          rules={[
            { required: true, message: '必须填写手机号' }, {
              validator: (rule, value, callback) => {
                checkAccount(value).then(res => {
                  if (res) {
                    callback()

                  } else {
                    callback('手机号码已存在，请查实后重试')
                  }
                })
              },
            }, {
              pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
              message: '请输入正确的手机号'
            }
          ]}>
          <Input placeholder="" onBlur={searchVip} disabled={showType == 'add' ? false : true} />
        </Form.Item>

        <Form.Item label="客户来源" name="customer_source_id" rules={[{ required: true, message: '必须填写手机号' }]}  >
          <Select placeholder="产康顾问" onChange={(value: string) => { handleSelectChange(value, 'customer_source_id') }} disabled={showType == 'add' ? false : true}>
            {getSourceList}
          </Select>
        </Form.Item>

        <Form.Item label="产康顾问" name="employee_id_adviser" rules={[{ required: true, message: '必须填写手机号' }]}  >
          <Select placeholder="产康顾问" showSearch
            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
            onChange={(value: string) => { handleSelectChange(value, 'employee_id_adviser') }}>
            {getAdviseEmployeeList}
          </Select>
        </Form.Item>

        <Form.Item label="备注" name="remark">
          <Input.TextArea placeholder="" />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>
  </div>
}